const DatePickerTranslations = {
    methods: {
        getShortWeekdays() {
            return [
                this.trans.get("datepicker.shortdays.monday"),
                this.trans.get("datepicker.shortdays.tuesday"),
                this.trans.get("datepicker.shortdays.wednesday"),
                this.trans.get("datepicker.shortdays.thursday"),
                this.trans.get("datepicker.shortdays.friday"),
                this.trans.get("datepicker.shortdays.saturday"),
                this.trans.get("datepicker.shortdays.sunday"),
            ];
        },
        getWeekdays() {
            return [
                this.trans.get("datepicker.days.sunday"),
                this.trans.get("datepicker.days.monday"),
                this.trans.get("datepicker.days.tuesday"),
                this.trans.get("datepicker.days.wednesday"),
                this.trans.get("datepicker.days.thursday"),
                this.trans.get("datepicker.days.friday"),
                this.trans.get("datepicker.days.saturday"),
            ];
        },
        getMonths() {
            return [
                this.trans.get("datepicker.months.january"),
                this.trans.get("datepicker.months.february"),
                this.trans.get("datepicker.months.march"),
                this.trans.get("datepicker.months.april"),
                this.trans.get("datepicker.months.may"),
                this.trans.get("datepicker.months.june"),
                this.trans.get("datepicker.months.july"),
                this.trans.get("datepicker.months.august"),
                this.trans.get("datepicker.months.september"),
                this.trans.get("datepicker.months.october"),
                this.trans.get("datepicker.months.november"),
                this.trans.get("datepicker.months.december"),
            ];
        }
    }
}

export default DatePickerTranslations;
